"use client"

import { Box, Button } from "@mui/material";
import { BadgeQuestionMarkIcon } from "lucide-react";
import Link from "next/link";

export default function PdpSizeHelper() {

    return (
        <Box sx={{
            mt: 1
        }}>
            <Button variant="text" sx={{
                fontSize: 15,
                fontWeight: 400,
            }} startIcon={<BadgeQuestionMarkIcon />} component={Link} href="/fa/guide/face-measurement" title="راهنمای سایز صورت">
                راهنمای سایز صورت
            </Button>
        </Box>
    )
}